// Hand-drawn 24px stroke icon set (no third-party icon license to track).

const PATHS = {
  gear: "M12 15.2a3.2 3.2 0 1 0 0-6.4 3.2 3.2 0 0 0 0 6.4ZM19.4 13.5l1.6 1.2-1.8 3.1-1.9-.7a7.4 7.4 0 0 1-2 1.2l-.3 2h-3.6l-.3-2a7.4 7.4 0 0 1-2-1.2l-1.9.7-1.8-3.1 1.6-1.2a7.6 7.6 0 0 1 0-2.4L3.4 9.9l1.8-3.1 1.9.7a7.4 7.4 0 0 1 2-1.2l.3-2h3.6l.3 2a7.4 7.4 0 0 1 2 1.2l1.9-.7 1.8 3.1-1.6 1.2a7.6 7.6 0 0 1 0 2.4Z",
  layout: "M4 4h7v9H4zM13 4h7v5h-7zM13 11h7v9h-7zM4 15h7v5H4z",
  check: "M5 12.5l4.2 4.2L19 7",
  plus: "M12 5v14M5 12h14",
  close: "M6 6l12 12M18 6L6 18",
  trash: "M4 7h16M10 11v6M14 11v6M6 7l1 12a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2l1-12M9 7V4h6v3",
  undo: "M9 14L4 9l5-5M4 9h10.5a5.5 5.5 0 0 1 0 11H11",
  redo: "M15 14l5-5-5-5M20 9H9.5a5.5 5.5 0 0 0 0 11H13",
  grip: "M9 5h.01M15 5h.01M9 12h.01M15 12h.01M9 19h.01M15 19h.01",
  expand: "M4 9V4h5M20 9V4h-5M4 15v5h5M20 15v5h-5",
  chevronLeft: "M15 5l-7 7 7 7",
  chevronRight: "M9 5l7 7-7 7",
  chevronDown: "M5 9l7 7 7-7",
  refresh: "M20 11a8 8 0 1 0-2.3 5.7M20 4v7h-7",
  locate: "M12 2v3M12 19v3M2 12h3M19 12h3M12 18a6 6 0 1 0 0-12 6 6 0 0 0 0 12ZM12 14a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z",
  home: "M4 11l8-7 8 7M6 9.5V20h12V9.5",
  calendar: "M4 6h16v14H4zM4 10h16M8 3v4M16 3v4",
  cloud: "M7 18h10a4 4 0 0 0 .6-8 6 6 0 0 0-11.5 1.4A3.4 3.4 0 0 0 7 18Z",
  radar: "M12 12l6-6M12 21a9 9 0 1 0-9-9M12 16a4 4 0 1 0-4-4",
  clock: "M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18ZM12 7v5l3 2",
  tasks: "M4 6l1.5 1.5L8 5M4 12l1.5 1.5L8 11M4 18l1.5 1.5L8 17M11 6h9M11 12h9M11 18h9",
  list: "M8 6h12M8 12h12M8 18h12M4 6h.01M4 12h.01M4 18h.01",
  alert: "M12 3l9.5 17h-19L12 3ZM12 10v4M12 17h.01",
  play: "M8 5v14l11-7L8 5Z",
  pause: "M8 5v14M16 5v14",
  copy: "M8 8h11v11H8zM5 16V5h11",
  user: "M12 12a4 4 0 1 0 0-8 4 4 0 0 0 0 8ZM4 21a8 8 0 0 1 16 0",
  signout: "M15 4h4v16h-4M10 8l-4 4 4 4M6 12h10",
  info: "M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18ZM12 11v5M12 8h.01",
  wifiOff: "M2 8.5a15 15 0 0 1 4-2.3M10 5.1A15 15 0 0 1 22 8.5M5 12a10 10 0 0 1 3.5-2M15 10a10 10 0 0 1 4 2M8.5 15.5a5 5 0 0 1 7 0M12 19h.01M3 3l18 18",
  sparkle: "M12 3l1.8 5.2L19 10l-5.2 1.8L12 17l-1.8-5.2L5 10l5.2-1.8L12 3Z",
  pin: "M12 21s-6-5.3-6-11a6 6 0 1 1 12 0c0 5.7-6 11-6 11ZM12 12a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z",
  sun: "M12 17a5 5 0 1 0 0-10 5 5 0 0 0 0 10ZM12 1v2M12 21v2M4.2 4.2l1.4 1.4M18.4 18.4l1.4 1.4M1 12h2M21 12h2M4.2 19.8l1.4-1.4M18.4 5.6l1.4-1.4",
  moon: "M20 14.5A8 8 0 1 1 9.5 4a6.5 6.5 0 0 0 10.5 10.5Z",
  edit: "M4 20h4L19 9l-4-4L4 16v4ZM13.5 6.5l4 4",
  drop: "M12 3.5c3.5 4.3 5.5 7.4 5.5 10a5.5 5.5 0 0 1-11 0c0-2.6 2-5.7 5.5-10Z",
  wind: "M3 9h11a3 3 0 1 0-3-3M3 15h15a3 3 0 1 1-3 3M3 12h7",
  globe: "M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18ZM3 12h18M12 3c2.5 2.6 3.8 5.6 3.8 9S14.5 18.4 12 21M12 3C9.5 5.6 8.2 8.6 8.2 12s1.3 6.4 3.8 9",
  umbrella: "M12 3a9 9 0 0 1 9 9H3a9 9 0 0 1 9-9ZM12 12v6.5a2 2 0 0 1-4 0",
  thermo: "M10 14.5V5a2 2 0 1 1 4 0v9.5a4 4 0 1 1-4 0ZM12 9v7",
  navigate: "M4 11l16-7-7 16-2-7-7-2Z",
  sync: "M4 12a8 8 0 0 1 13.7-5.7L20 8.5M20 4v4.5h-4.5M20 12a8 8 0 0 1-13.7 5.7L4 15.5M4 20v-4.5h4.5",
  lock: "M6 11h12v10H6zM8.5 11V7.5a3.5 3.5 0 0 1 7 0V11",
  unlock: "M6 11h12v10H6zM8.5 11V7.5a3.5 3.5 0 0 1 6.8-1.2",
  utensils: "M7 3v8M5 3v5a2 2 0 0 0 4 0V3M7 11v10M17 3c-2 1.5-3 4-3 7h3v11",
  image: "M4 5h16v14H4zM4 16l5-5 4 4 3-3 4 4M15.5 9.5h.01",
  heart: "M12 20s-7.5-4.6-7.5-10.2A4.3 4.3 0 0 1 12 7.2a4.3 4.3 0 0 1 7.5 2.6C19.5 15.4 12 20 12 20Z",
  flag: "M5.5 21V4M5.5 4.5h12l-2.5 4.25 2.5 4.25h-12",
  star: "M12 3.5l2.6 5.3 5.9.9-4.3 4.1 1 5.8L12 16.9l-5.2 2.7 1-5.8-4.3-4.1 5.9-.9L12 3.5Z",
  flame: "M12 21a6 6 0 0 0 6-6c0-3.5-2.5-5.5-3.5-9-1.5 2-2 3.5-2 5-1-1-1.5-2-1.5-3.5C8.5 9.5 6 12 6 15a6 6 0 0 0 6 6ZM12 21a2.5 2.5 0 0 1-2.5-2.5c0-1.5 1.5-2.5 2.5-4 1 1.5 2.5 2.5 2.5 4A2.5 2.5 0 0 1 12 21Z",
  mountain: "M2 20l7-12 4 6 2.5-3.5L22 20H2ZM7.5 10.5l1.5 1.5 1.5-1.5",
  waves: "M3 8c1.5 0 1.5-1.5 3-1.5S7.5 8 9 8s1.5-1.5 3-1.5S13.5 8 15 8s1.5-1.5 3-1.5S19.5 8 21 8M3 13c1.5 0 1.5-1.5 3-1.5S7.5 13 9 13s1.5-1.5 3-1.5 1.5 1.5 3 1.5 1.5-1.5 3-1.5 1.5 1.5 3 1.5M3 18c1.5 0 1.5-1.5 3-1.5S7.5 18 9 18s1.5-1.5 3-1.5 1.5 1.5 3 1.5 1.5-1.5 3-1.5 1.5 1.5 3 1.5",
  note: "M5 4h14v11l-5 5H5zM14 20v-5h5M8.5 9h7M8.5 12.5h4",
  hourglass: "M7 3h10M7 21h10M8 3c0 4.5 4 5.5 4 9s-4 4.5-4 9M16 3c0 4.5-4 5.5-4 9s4 4.5 4 9",
  gauge: "M4.5 17a8.5 8.5 0 1 1 15 0M12 13l4-5M12 13h.01",
  eye: "M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7S2 12 2 12ZM12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z",
  leaf: "M5 19c0-8 5-14 15-15-1 10-7 15-15 15ZM5 19l7-7",
  bolt: "M13 2L4.5 13.5H11L10 22l8.5-11.5H12L13 2Z",
  bike: "M2 16a3.5 3.5 0 1 0 7 0 3.5 3.5 0 1 0-7 0ZM15 16a3.5 3.5 0 1 0 7 0 3.5 3.5 0 1 0-7 0ZM5.5 16L9 9h6.5l3 7M9 9l3 7 3.5-7M12 16H5.5M7.5 7h3M15.5 9l-.8-2.5H17",
  hiker: "M11.5 4.5a1.5 1.5 0 1 0 3 0 1.5 1.5 0 1 0-3 0ZM12.5 8.5l-1.5 5 3 3V21M11 13.5L8.5 21M12.5 8.5l3 3 2.5.8M18 10v11M12.5 8.5L9 10.5l-1 3",
  target: "M12 20a8 8 0 1 0 0-16 8 8 0 0 0 0 16ZM12 2v5M12 17v5M2 12h5M17 12h5M12 12h.01",
  fish: "M3 12c3-4.5 9-6 14-2l4-3v10l-4-3c-5 4-11 2.5-14-2ZM8 11h.01",
  canoe: "M2 14c4 3.5 16 3.5 20 0-5-1.6-15-1.6-20 0ZM15.5 3L11 17M10.2 19.5l.8-2.5",
  tent: "M3 20L12 4l9 16H3ZM12 4v16M9 20l3-6 3 6",
  moonCheck: "M20 14.5A8 8 0 1 1 9.5 4a6.5 6.5 0 0 0 10.5 10.5ZM9 13l2 2 4-4",
  board: "M3 5h18v11H3zM8 20l2-4M16 20l-2-4M6.5 12.5c1.5-3 3-3 4.5-1s3 2 4.5-1.5",
  pen: "M4 20l1.2-4.6L15.8 4.8a2.2 2.2 0 0 1 3.1 3.1L8.3 18.5 4 20ZM13.8 6.8l3.4 3.4",
  marker: "M9 15l-3 3h-3l3-3M7.5 13.5l7.5-9.5 5 5-9.5 7.5-3-3ZM4 21h16",
  eraser: "M8.5 19.5l-4-4a2 2 0 0 1 0-2.8L13.2 4a2 2 0 0 1 2.8 0l4 4a2 2 0 0 1 0 2.8l-8.7 8.7H8.5ZM9 9.5l5.5 5.5M8.5 19.5H20",
  dice: "M5 4h14a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1ZM8.5 8.5h.01M15.5 8.5h.01M12 12h.01M8.5 15.5h.01M15.5 15.5h.01",
  news: "M4 5h13v14a1 1 0 0 0 1 1H5a1 1 0 0 1-1-1V5ZM17 9h3v10a1 1 0 0 1-2 0M7 9h7M7 13h7M7 16h4",
  satellite: "M9.5 9.5l5 5M8 11l3-3 5 5-3 3-5-5ZM4 7l3-3 3 3-3 3-3-3ZM14 17l3-3 3 3-3 3-3-3ZM4.5 14.5a5 5 0 0 0 5 5M4.5 18a1.5 1.5 0 0 0 1.5 1.5",
  trophy: "M8 4h8v5a4 4 0 0 1-8 0V4ZM8 6H5a3 3 0 0 0 3 4M16 6h3a3 3 0 0 1-3 4M12 13v4M8 20h8M9.5 17h5",
  snow: "M12 3v18M4.2 7.5l15.6 9M4.2 16.5l15.6-9M9.5 4.5L12 6l2.5-1.5M9.5 19.5L12 18l2.5 1.5",
  car: "M5 16h14v-4l-2-5H7l-2 5v4ZM5 12h14M7.5 16v2M16.5 16v2M8 14h.01M16 14h.01",
  layers: "M12 3l9 5-9 5-9-5 9-5ZM3 12.5l9 5 9-5M3 17l9 5 9-5",
  phone: "M8 2.5h8a1.5 1.5 0 0 1 1.5 1.5v16a1.5 1.5 0 0 1-1.5 1.5H8A1.5 1.5 0 0 1 6.5 20V4A1.5 1.5 0 0 1 8 2.5ZM11 18.5h2",
  road: "M9 3L5 21M15 3l4 18M12 4v2.5M12 10.5v3M12 17.5V20",
  camera: "M4 8h3.2l1.6-2.5h6.4L16.8 8H20v11H4zM12 16.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7Z",
  ski: "M15 4.5a1.5 1.5 0 1 0 3 0 1.5 1.5 0 1 0-3 0ZM3 14.5l18 6.5M7.5 10.5l4-3 3.5 3-3 3 1 4.5M11.5 7.5L8 6.5M15 10.5l3.5 1.5",} as const;

export type IconName = keyof typeof PATHS;

/** `size`: a number is px; a string is any CSS length (rem scales with the screen). */
export function Icon({ name, size = "1.35rem", className, title }: { name: IconName; size?: number | string; className?: string; title?: string }) {
  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.8}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden={title ? undefined : true}
      role={title ? "img" : undefined}
    >
      {title && <title>{title}</title>}
      <path d={PATHS[name]} />
    </svg>
  );
}
